export default function DownloadSection() {
  return (
    <section id="download" className="relative w-full py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20dark%20luxury%20background%20with%20warm%20golden%20accents%20and%20subtle%20geometric%20patterns%2C%20premium%20texture%20with%20soft%20metallic%20reflections%2C%20sophisticated%20and%20modern%20aesthetic%2C%20deep%20rich%20colors%2C%20abstract%20luxury%20design%20with%20flowing%20organic%20shapes%2C%20no%20text&width=1800&height=700&seq=download-cta-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-foreground-950/85"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center px-4 md:px-6">
        <span className="inline-block px-3 py-1 rounded-full bg-primary-500/20 border border-primary-400/30 text-primary-200 text-xs font-medium mb-5">
          安全下载 · 官方正版
        </span>
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          立即下载澳门新葡京app
        </h2>
        <p className="text-base text-background-50/70 max-w-xl mx-auto mb-8">
          选择您的设备平台，下载官方正版app，开启顶级娱乐体验
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <button className="w-full sm:w-auto px-8 py-4 rounded-xl bg-primary-500 text-background-50 font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer shadow-lg shadow-primary-500/30 flex items-center justify-center gap-3">
            <i className="ri-android-line text-xl"></i>
            <div className="text-left">
              <div className="text-xs opacity-80">Android 版本</div>
              <div className="text-sm">安卓下载</div>
            </div>
          </button>
          <button className="w-full sm:w-auto px-8 py-4 rounded-xl bg-background-50 text-foreground-950 font-semibold whitespace-nowrap hover:bg-background-100 transition-all duration-300 cursor-pointer shadow-lg shadow-black/20 flex items-center justify-center gap-3">
            <i className="ri-apple-line text-xl"></i>
            <div className="text-left">
              <div className="text-xs opacity-60">iOS 版本</div>
              <div className="text-sm">苹果下载</div>
            </div>
          </button>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 text-xs text-background-50/50">
          <div className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-primary-400"></i>
            官方正版认证
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-lock-line text-primary-400"></i>
            SSL安全加密
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-smartphone-line text-primary-400"></i>
            多平台兼容
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-refresh-line text-primary-400"></i>
            免费更新升级
          </div>
        </div>
      </div>
    </section>
  );
}